import Tr from 'translations/Translations';
import {createSelectItem} from "components/Select";
import {AuctionRule} from "constants/AuctionRule";

export const AuctionItemBidType = {


    RFX_CRITERIUM_VALUE: "RFX_CRITERIUM_VALUE",//domyślaa prezentuje wszystkie kryteria zwrócone, bez itemsów
    /**
     *  (tylko dla japońskich, gdy jest jedna pozycja (items=1))
     */
    RFX_CRITERIUM_PRICE: "RFX_CRITERIUM_PRICE", //(tutaj itemsy), bez kryterium typ price, reszta kryt. tak
    /**
     *  (tylko dla aukcji angielskich i dynamicznych)
     */
    RFX_ITEM_VALUE: "RFX_ITEM_VALUE" //(tutaj itemsy), bez kryterium typ price, reszta kryt. tak
}
const _TR_PREFIX = 'auction_item_bid_type_';

export const AuctionItemBidTypeLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));

export const AuctionItemBidTypeItems = (auctionRule, allowQuantityEditInOffer, fixedOfferVat, optionItemsExist, itemsCount) => {
    console.log('auctionRule: ' + auctionRule)
    if ((auctionRule === AuctionRule.ENGLISH || auctionRule === AuctionRule.DYNAMIC) && !allowQuantityEditInOffer && !fixedOfferVat && optionItemsExist) {
        return [createSelectItem(AuctionItemBidType.RFX_ITEM_VALUE, AuctionItemBidTypeLabel(AuctionItemBidType.RFX_ITEM_VALUE))];
    }

    const arr = [createSelectItem(AuctionItemBidType.RFX_CRITERIUM_VALUE, AuctionItemBidTypeLabel(AuctionItemBidType.RFX_CRITERIUM_VALUE))];
    if ((auctionRule === AuctionRule.ENGLISH || auctionRule === AuctionRule.DYNAMIC) && !allowQuantityEditInOffer && !fixedOfferVat && itemsCount > 1) {
        arr.push(createSelectItem(AuctionItemBidType.RFX_ITEM_VALUE, AuctionItemBidTypeLabel(AuctionItemBidType.RFX_ITEM_VALUE)))
    }
    return arr;
}